export function isEmptyObject(obj: object): boolean {
  return obj && typeof obj === 'object' && Object.keys(obj).length === 0;
}
